import logger from '@/logger';
import type { LocationQueryValue, Router } from 'vue-router';

const log = logger.getChild('sidebar');

export enum SIDEBAR {
  PHONE = 'PHONE',
  PHONE_EDIT = 'PHONE_EDIT',
  // temporary
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
}

export const sidebarValues = new Set(Object.values(SIDEBAR));

export type SidebarMeta = {
  id?: string;
  tab?: string;
  csvId?: string;
  currentDay?: string;
};

export type SidebarProps = {
  meta: SidebarMeta | null;
};

let router: Router;
export const initSidebar = (initRouter: Router): void => {
  router = initRouter;
};

export const getSidebarByString = (
  name: string | undefined | null | LocationQueryValue[],
): SIDEBAR | null => {
  if (!name || Array.isArray(name) || !sidebarValues.has(name as SIDEBAR)) {
    return null;
  }
  return name as SIDEBAR;
};

export const parseSidebarMeta = (
  meta: string | undefined | null | LocationQueryValue[],
): SidebarMeta | null => {
  if (!meta || Array.isArray(meta)) {
    return null;
  }
  try {
    const parsed = JSON.parse(meta);
    if (typeof parsed !== 'object') {
      log.error(`Invalid sidebar meta: ${meta}`);
      return null;
    }

    // prevent potential XSS
    return {
      id: parsed.id,
      tab: parsed.tab,
      csvId: parsed.csvId,
      currentDay: parsed.currentDay,
    };
  } catch {
    log.error(`Invalid sidebar meta: ${meta}`);
    return null;
  }
};

export const openSidebar = async (
  sidebar: SIDEBAR,
  meta?: SidebarMeta,
): Promise<void> => {
  log.log('Opening sidebar', { sidebar, meta });
  await router.push({ query: { sidebar, sidebarMeta: JSON.stringify(meta) } });
};

export const closeSidebar = async (): Promise<void> => {
  log.log('Closing sidebar');
  await router.push({
    query: {
      ...router.currentRoute.value.query,
      sidebar: undefined,
      sidebarMeta: undefined,
    },
  });
};

export const updateSidebarShow = async (show: boolean): Promise<void> => {
  if (!show) {
    await closeSidebar();
  }
};
